module.exports = __webpack_public_path__ + "img/dd5.713a48a5.png";